<form [formGroup]="projectIdeaForm" class="needs-validation" novalidate="">
  <app-card [titleKey]="'newProjectIdea.provideFollowingData'">
    <app-project-idea-fields [form]="projectIdeaForm" />
  </app-card>
  <!-- <div class="card">
    <div class="card-header">
      {{ "newProjectIdea.provideFollowingData" | translate }}
    </div>
    <div class="card-body">

    </div>
  </div> -->
  <div class="col-auto d-flex justify-content-end my-2 mt-4">
    <app-button
      btnClass="btn btn-primary"
      type="submit"
      [label]="'newProjectIdea.sendTo' | translate"
      iconClass="fab fa-telegram-plane btn-icon"
      [loading]="loading()"
      (clicked)="submitIdea()"
    ></app-button>
  </div>
</form>
